import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  AccessType,
  ILocationPermission,
} from '@kinet-open-network/shared/data-access/model';

export class LocationPermission
  extends BaseModel<LocationPermission, 'LocationPermission'>
  implements ILocationPermission
{
  static override readonly modelName: AbilitySubjectType = 'LocationPermission';
  county!: string;
  city!: string;
  district!: string;
  accessType!: AccessType;
  isAllowed!: boolean;

  get label() {
    return [this.county, this.city, this.district].filter(Boolean).join(', ');
  }
}
